import { NearMissForbidden } from "./components/NearMissForbidden";

export default NearMissForbidden;